module.exports = __webpack_public_path__ + "img/siqicon.61807e82.svg";